export class LoadChoiceValueForEditing {
  static type = '[ChoiceValuesAdmin] LoadChoiceValuesForEditing';

  constructor(public name: string) {
  }
}
